import { render } from "./CardUser.vue?vue&type=template&id=0cc43d6e&scoped=true"
import script from "./CardUser.vue?vue&type=script&lang=js"
export * from "./CardUser.vue?vue&type=script&lang=js"

import "./CardUser.vue?vue&type=style&index=0&id=0cc43d6e&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cc43d6e"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
